import * as React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { useHistory } from 'react-router-dom';
import { Typography, AppBar, Toolbar, IconButton, Menu, Container, Link } from '@material-ui/core';
import { Settings as SettingsIcon } from '@material-ui/icons';

const styles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(1)
    },
    title: {
        flexGrow: 1
    },
    titleLink: {
        // textDecoration: 'none',
        // textDecorationColor: theme.palette.primary.contrastText
    },
    contentContainer: {
        paddingLeft: theme.spacing(10),
        paddingRight: theme.spacing(10)
    }
}));

export interface ComponentProps {
    title?: string;
    onSettingsClick?: () => void;
}
export function TitleBar({ title = 'Gnosis Tester', onSettingsClick }: ComponentProps) {
    const classes = styles();

    const history = useHistory();

    const onTitleClick = (e: React.SyntheticEvent) => {
        e.preventDefault();

        history.push('/');
    }

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Typography className={classes.title} variant="h4"><Link href="#" onClick={onTitleClick} color="inherit" underline="none">{title}</Link></Typography>
                        <IconButton color="default" onClick={onSettingsClick}>
                            <SettingsIcon />
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>
        </div>
    );
}